export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validateMobileNo = (mobile_no) => {
  const mobileRegex = /^\d{10}$/;
  return mobileRegex.test(mobile_no);
};

export const validatePassword = (password) => {
  const passwordRegex = /^.{6,}$/;
  return passwordRegex.test(password);
};

export const validateOtp = (otp) => {
  const otpRegex = /^\d{6}$/;
  return otpRegex.test(otp);
};

export const isValidCallbackUrl = (url) => {
  return /^https?:\/\//i.test(url);
};